import {each, reduce} from '../lang/array';

const
    Entry = class Entry {
        constructor(collection, value, index) {
            this.collection = collection;
            this.value = value;
            this.index = index;
        }

        remove() {
            if (this.collection) {
                this.collection.entries[this.index] = null;
                this.collection.count -= 1;
                this.collection.compact();
                this.collection = null;
                this.value = null;
            }
        }
    },

    minimum = 8,

    maximum = 32,

    threshold = 0.5,

    compact = collection => {
        if (!collection.compacted) {
            collection.entries = (
                reduce(
                    collection.entries,
                    (entries, entry) => {
                        if (entry) {
                            entry.index = entries.length;
                            entries.push(entry);
                        }
                        return entries;
                    },
                    []));
            collection.compacted = true;
        }
    },

    Collection = class Collection {
        constructor() {
            this.compacted = true;
            this.entries = [];
            this.count = 0;
        }

        add(value) {
            compact(this);
            const
                entry = (
                    new Entry(
                        this,
                        value,
                        this.entries.length));

            this.entries.push(entry);
            this.count += 1;
            return entry;
        }

        each(fn) {
            compact(this);
            each(this.entries, entry => {
                if (entry) {
                    fn(entry.value);
                }
            });
        }

        compact() {
            if (this.compacted) {
                const empty = this.entries.length - this.count;

                if (empty >= maximum || (
                        empty >= minimum &&
                        ((this.count / this.entries.length) <= threshold))) {

                    this.compacted = false;
                }
            }
            return this;
        }
    };

export {
    Collection
};
